<template>
  <div>
    <v-container grid-list-xl fluid class="px-8 py-4">
      <div class="mb-3">
        <h1 class="fs-18 lh-18 text-uppercase mt-1 font-weight-700">
          USER MAPPING
        </h1>
        <v-breadcrumbs class="px-0 py-2" :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <v-row no-gutters align="center" justify="space-between" class="mb-3">
        <v-col cols="12" sm="6">
          <h1 class="fs-20 font-weight-bold bluedarken--text">
            {{ isEdit ? 'Edit' : 'Add New' }} User Mapping
          </h1>
        </v-col>
        <v-col cols="12" sm="auto" class="px-0">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" icon medium v-on="on">
                <v-icon
                  @click="getData"
                  color="bluedarken"
                  class="icon-bold icon-large"
                  large
                >
                  mdi-refresh
                </v-icon>
              </v-btn>
            </template>
            <span>
              Refresh
            </span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-card :loading="loading" class="elevation-card rounded-10">
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-0">
            <v-card-text class="pb-0">
              <v-row>
                <v-col cols="12" class="py-0">
                  <label
                    class="mb-1 d-block fs-12 font-weight-regular"
                    for="region"
                  >
                    Region
                  </label>
                  <ValidationProvider name="Region" v-slot="{ errors }">
                    <v-autocomplete
                      id="region"
                      placeholder="Select Region"
                      single-line
                      dense
                      outlined
                      clearable
                      :error-messages="errors"
                      v-model="item.region_mapping_id"
                      autocomplete="off"
                      :items="regions"
                      @change="getDistrictByRegion"
                      item-value="id"
                      item-text="name"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" class="py-0">
                  <label
                    class="mb-1 d-block fs-12 font-weight-regular"
                    for="district"
                  >
                    District
                  </label>
                  <ValidationProvider name="District" v-slot="{ errors }">
                    <v-autocomplete
                      id="district"
                      placeholder="Select District"
                      single-line
                      clearable
                      dense
                      outlined
                      :items="districts"
                      v-model="item.district_mapping_id"
                      item-value="id"
                      item-text="name"
                      :disabled="districts.length < 1"
                      :filled="districts.length < 1"
                      autocomplete="off"
                      :error-messages="errors"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" class="py-0">
                  <label
                    class="mb-1 d-block fs-12 font-weight-regular"
                    for="group"
                  >
                    Group
                  </label>
                  <ValidationProvider
                    name="Group"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-autocomplete
                      id="group"
                      placeholder="Select Group"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="item.group_id"
                      autocomplete="off"
                      :items="groups"
                      item-value="id"
                      item-text="name"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" class="py-0">
                  <label
                    class="mb-1 d-block fs-12 font-weight-regular"
                    for="user"
                  >
                    User
                  </label>
                  <ValidationProvider
                    name="User"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-autocomplete
                      id="user"
                      placeholder="Select User"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="item.user_id"
                      autocomplete="off"
                      :items="users"
                      item-value="id"
                      item-text="email"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pb-6 px-6">
              <v-spacer></v-spacer>
              <v-btn
                color="#bd1e19"
                dark
                to="/sshcp/approval/user"
                class="btn-medium px-4"
              >
                Cancel
              </v-btn>
              <v-btn color="primary" class="btn-medium px-4" dark type="submit">
                {{ isEdit ? 'Save' : 'Submit' }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '@/components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '@/mixins/ACLMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  props: ['id'],
  mixins: [ACLMixin],
  data() {
    return {
      progressDialogLoading: false,
      loading: true,
      breadcrumbs: [
        {
          text: 'Approval Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'User Mapping List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: 'Add New User Mapping',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      timeout: null,
      isEdit: false,
      regions: [],
      districts: [],
      groups: [],
      users: [],
      item: {
        region_mapping_id: null,
        district_mapping_id: null,
        group_id: null,
        user_id: null
      }
    };
  },
  watch: {
    descending() {
      this.getData();
    }
  },
  mounted() {
    if (this.id) {
      this.isEdit = true;
    }
    this.getData();
  },
  methods: {
    searchBrand() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    async getData() {
      if (this.id) {
        await this.getDetail();
      }
      await this.getRegions();
      await this.getDistrictByRegion();
      await this.getGroups();
      await this.getUsers();
    },
    getDetail() {
      this.loading = true;
      return this.$store
        .dispatch('sshcp/getDetailUserMapping', { id: this.id })
        .then(data => {
          this.loading = false;
          if (data.code === 200) {
            this.item = data.data.result;
          } else {
            this.loading = false;
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.loading = false;
          Swal.fire('Failed!', err.message.text_en, 'error');
        });
    },
    getRegions() {
      this.loading = true;
      return this.$store
        .dispatch('sshcp/getRegionsMapping', {
          paginate: false,
          filter: {
            column: 'type',
            data: 'sshcp'
          }
        })
        .then(data => {
          this.loading = false;
          if (data.code === 200) {
            this.regions = data.data;
          } else {
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.loading = false;
          Swal.fire('Failed!', err.message.text_en, 'error');
        });
    },
    getGroups() {
      this.loading = true;
      return this.$store
        .dispatch('sshcp/getGroup', {
          paginate: false
        })
        .then(data => {
          this.loading = false;
          if (data.code === 200) {
            this.groups = data.data;
          } else {
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.loading = false;
          Swal.fire('Failed!', err.message.text_en, 'error');
        });
    },
    getUsers() {
      this.loading = true;
      return this.$store
        .dispatch('sshcp/getUserSSHCP', {
          paginate: false
        })
        .then(data => {
          this.loading = false;
          if (data.code === 200) {
            this.users = data.data.result;
          } else {
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.loading = false;
          Swal.fire('Failed!', err.message.text_en, 'error');
        });
    },
    getDistrictByRegion() {
      if (this.item.region_mapping_id) {
        this.loading = true;
        return this.$store
          .dispatch('sshcp/getDistrictByRegion', {
            paginate: false,
            id: this.item.region_mapping_id
          })
          .then(data => {
            this.loading = false;
            if (data.code === 200) {
              this.districts = data.data.districtMappings;
            } else {
              this.loading = false;
              Swal.fire('Failed!', data.message.text_en, 'error');
            }
          })
          .catch(err => {
            this.loading = false;
            Swal.fire('Failed!', err.message.text_en, 'error');
          });
      } else {
        this.item.region_mapping_id = null;
        this.item.district_mapping_id = null;
        this.districts = [];
      }
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        Swal.fire({
          title: '',
          text: 'Are you sure want to save this data?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then(result => {
          if (result.value) {
            this.progressDialogLoading = true;
            if (!this.isEdit) {
              return this.$store
                .dispatch('sshcp/createUserMapping', this.item)
                .then(data => {
                  this.progressDialogLoading = false;
                  if (data.code === 200) {
                    Swal.fire('Success!', data.message.text_en, 'success');
                    this.$router.push({
                      name: 'sshcp_user_mapping'
                    });
                  } else {
                    this.progressDialogLoading = false;
                    Swal.fire('Failed!', data.message.text_en, 'error');
                  }
                })
                .catch(err => {
                  this.progressDialogLoading = false;
                  Swal.fire('Failed!', err.message.text_en, 'error');
                });
            } else {
              return this.$store
                .dispatch('sshcp/updateUserMapping', {
                  id: this.id,
                  data: this.item
                })
                .then(data => {
                  this.progressDialogLoading = false;
                  this.isSearch = false;
                  if (data.code === 200) {
                    Swal.fire('Success!', data.message.text_en, 'success');
                    this.$router.push({
                      name: 'sshcp_user_mapping'
                    });
                  } else {
                    this.progressDialogLoading = false;
                    Swal.fire('Failed!', data.message.text_en, 'error');
                  }
                })
                .catch(err => {
                  this.loading = false;
                  Swal.fire('Failed!', err.message.text_en, 'error');
                });
            }
          }
        });
      }
    }
  }
};
</script>
